import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, unref as _unref, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-54487ca2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tasks" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "task-title" }, "任务消息", -1))
const _hoisted_3 = { class: "task-content" }
const _hoisted_4 = {
  class: /*#__PURE__*/_normalizeClass(['task-tr', 'xn-flex-center'])
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "mb2" }
const _hoisted_8 = { class: "task-subtitle s4-mr" }
const _hoisted_9 = {
  key: 0,
  class: "task-tag"
}
const _hoisted_10 = { class: "mb2 xn-tip xn-flex-center" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "状态：", -1))
const _hoisted_12 = { class: "task-column" }
const _hoisted_13 = {
  key: 0,
  class: "xn-error"
}
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { key: 2 }
const _hoisted_16 = { key: 3 }
const _hoisted_17 = { class: "task-opera" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = {
  key: 1,
  class: "task-column"
}

import { ref, nextTick } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import { Empty } from 'ant-design-vue'
import { CloseOutlined } from '@ant-design/icons-vue'
import { stopTask } from '@/api/task'
import Detail from '@/views/taskCenter/detail.vue'


interface Props {
  tasks: any[]
  getTasks: Function
}


export default /*#__PURE__*/_defineComponent({
  __name: 'tasks',
  props: {
    tasks: {},
    getTasks: { type: Function }
  },
  setup(__props: any) {

const props = __props
const store = useStore()
const router = useRouter()
const open = ref<boolean>(false)
const curRow = ref<any>({})
const simpleImage = Empty.PRESENTED_IMAGE_SIMPLE
// 可点击状态
const isClickStatus = ['RUNNING_SUCCESS', 'STOP', 'RUNNING_FAIL']
// 可临时任务
const isTempTask = ['UPLOAD_FILE', 'COMPRESS', 'DECOMPRESS']

const closeTaskBox = () => {
  nextTick(() => {
    store.commit('tempTask/triggerTask', false)
  })
}

const toTaskCenter = () => {
  router.push('/taskCenter')
  closeTaskBox()
}

const onClose = () => open.value = false
const previewDetail = (row) => {
  if (isClickStatus.includes(row.taskStatus)) {
    curRow.value = row
    open.value = true
    closeTaskBox()
  }
}

const extractLastSlash = (str) => {
  let res = ''
  if (str) {
    const lastIndex = str.lastIndexOf('/')
    res = str.substring(lastIndex + 1)
  }
  return res
}

const getRunningDesc = (type, task) => {
  if (type === 'UPLOAD_FILE') {
    return `已上传${task.uploaded}个文件${task.size ? `（${task.size}）` : ''}，${task.failed ? '失败'+ task.failed +'个，' : ''}剩余${task.uploading}个文件，正在上传第${task.whichFile}个文件进度${task.ratio}%`
  }
  if (type === 'SITE_MOVE') {
    let curFile = ''
    if (task.file?.processing) {
      curFile = extractLastSlash(task.file.processing)
    }
    return `已搬运${task.file?.copiedFiles || 0}个文件${task.file?.copiedBytes ? `（${task.file.copiedBytes}）` : ''}，正在传输${curFile}`
  }
  if (type === 'DECOMPRESS') {
    const filename = extractLastSlash(task.filename)
    return `正在解压 ${filename} ${task.processed}/${task.total}`
  }
  if (type === 'COMPRESS') {
    if (task.progress) {
      return `正在下载，进度${task.progress}%`
    }
    if (task.downloaded) {
      return `正在下载，已下载${task.downloaded}，下载速度${task.rate}`
    }
    return '正在下载'
  }
  if (type === 'APP_INSTALL') {
    try {
      return `正在安装 ${JSON.parse(task.taskParam)?.appName}`
    } catch(e) {
      return ''
    }
  }
  if (type === 'WEB_BACKUP') return '正在备份'
  if (type === 'DB_BACKUP') return '正在备份'
  if (type === 'WEB_BACKUP_RESTORE') return '正在恢复'
}

const getSuccessDesc = (type, task) => {
  if (type === 'UPLOAD_FILE') {
    return `共上传${task.succeed}个文件${task.totalSize ? `（${task.totalSize}）` : ''}`
  }
  if (type === 'SITE_MOVE') {
    return `共搬运${task.file?.copiedFiles || 0}个文件${task.file?.copiedBytes ? `（${task.file.copiedBytes}）` : ''}`
  }
  if (type === 'DECOMPRESS') return '解压完成'
  // if (type === 'COMPRESS') return `已压缩下载为 ${extractLastSlash(task.filename)}`
  if (type === 'COMPRESS') return '下载文件任务已完成'
  if (type === 'APP_INSTALL') {
    try {
      const { appName, targetPath } = JSON.parse(task.taskParam)
      return `${appName} 已安装到 ${targetPath} 目录`
    } catch(e) {
      return ''
    }
  }
  if (type === 'WEB_BACKUP') {
    if (task?.taskInfo === 'empty') {
      return '不存在可进行备份的数据'
    }
    try {
      return `已备份到 ${task.taskInfo.slice(task.taskInfo.lastIndexOf('/') + 1)}`
    } catch(e) {
      return ''
    }
  }
  if (type === 'DB_BACKUP') {
    if (task?.taskInfo === 'empty') {
      return '不存在可进行备份的数据'
    }
    try {
      return `已备份到 ${task.taskInfo.slice(task.taskInfo.lastIndexOf('/') + 1)}`
    } catch(e) {
      return ''
    }
  }
  if (type === 'WEB_BACKUP_RESTORE') return '已恢复网站文件'
}

const getTaskStatus = (value) => {
  return Xinnet.settings.taskStatusOpts.find((o) => (
    o.value === value
  ))?.text
}

const getTaskType = (value, key) => {
  return Xinnet.settings.taskTypeOpts.find((o) => {
    return o.value === value
  })?.[key]
}

const stop = async (row, done?) => {
  try {
    const res: any = await stopTask(row.id)
    Xinnet.message.success(res.res)

    const { hostInfo } = store.state
    if (hostInfo?.hostService?.hostName) {
      props.getTasks?.(hostInfo.hostService.hostName, false)
    }
  } catch(e) {
    
  } finally {
    done?.()
  }
}

const openStopModal = (row) => {
  const content = row.taskType === 'SITE_MOVE'
    ? '网站搬家终止后，将无任何文件保存到目标路径，是否要终止已经进行的任务?'
    : '是否要终止已经进行的任务？'
  const api = row.taskType === 'UPLOAD_FILE'
    ? (done) => (store.commit('tempTask/stopTask'), done())
    : (done) => stop(row, done)

  store.commit('modal/open', {
    uid: 'tip',
    modal: {
      title: '确认终止',
      content,
      okDanger: true,
      api,
    }
  })
}

const toStop = (o) => {
  o.taskStatus === 'WAIT' ? stop(o) : openStopModal(o)
}

return (_ctx: any,_cache: any) => {
  const _component_xn_icon = _resolveComponent("xn-icon")!
  const _component_a_empty = _resolveComponent("a-empty")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_drawer = _resolveComponent("a-drawer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        (_ctx.tasks.length)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.tasks, (o) => {
              return (_openBlock(), _createElementBlock("div", {
                key: o.id,
                class: "task-tr-wrap"
              }, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", {
                    class: _normalizeClass(['xn-flex-center', { 'xn-pointer': isClickStatus.includes(o.taskStatus) }]),
                    onClick: ($event: any) => (previewDetail(o))
                  }, [
                    _createVNode(_component_xn_icon, {
                      class: "task-icon",
                      icon: getTaskType(o.taskType, 'icon')
                    }, null, 8, ["icon"])
                  ], 10, _hoisted_5),
                  _createElementVNode("div", {
                    class: _normalizeClass(['task-td', { 'xn-pointer': isClickStatus.includes(o.taskStatus) }]),
                    onClick: ($event: any) => (previewDetail(o))
                  }, [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("span", _hoisted_8, _toDisplayString(getTaskType(o.taskType, 'text')), 1),
                      (isTempTask.includes(o.taskType))
                        ? (_openBlock(), _createElementBlock("span", _hoisted_9, " 临时任务 "))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                      _hoisted_11,
                      _createElementVNode("span", {
                        class: "task-column",
                        style: _normalizeStyle(`color: ${_ctx.$util.getBadgeColor(o.taskStatus)}`)
                      }, _toDisplayString(getTaskStatus(o.taskStatus)), 5)
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                      (['RUNNING_FAIL', 'STOP'].includes(o.taskStatus))
                        ? (_openBlock(), _createElementBlock("span", _hoisted_13, " 任务失败，请点击查看详情 "))
                        : _createCommentVNode("", true),
                      (['WAIT'].includes(o.taskStatus))
                        ? (_openBlock(), _createElementBlock("span", _hoisted_14, " 等待中 "))
                        : _createCommentVNode("", true),
                      (['RUNNING'].includes(o.taskStatus))
                        ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(getRunningDesc(o.taskType, o)), 1))
                        : _createCommentVNode("", true),
                      (['RUNNING_SUCCESS'].includes(o.taskStatus))
                        ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(getSuccessDesc(o.taskType, o)), 1))
                        : _createCommentVNode("", true)
                    ])
                  ], 10, _hoisted_6),
                  _createElementVNode("div", _hoisted_17, [
                    (['RUNNING', 'WAIT'].includes(o.taskStatus) && ['SITE_MOVE'].includes(o.taskType))
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          class: "task-column xn-pointer",
                          onClick: ($event: any) => (toStop(o))
                        }, [
                          _createVNode(_unref(CloseOutlined))
                        ], 8, _hoisted_18))
                      : (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(o.endTime ? o.endTime.slice(0, 10) : ''), 1))
                  ])
                ])
              ]))
            }), 128))
          : (_openBlock(), _createBlock(_component_a_empty, {
              key: 1,
              image: _unref(simpleImage),
              description: "近期无任务"
            }, null, 8, ["image"]))
      ]),
      _createElementVNode("div", {
        class: "task-more",
        style: _normalizeStyle({ marginTop: _ctx.tasks.length === 1 ? '60px' : '8px' })
      }, [
        _createVNode(_component_a_button, {
          type: "link",
          onClick: toTaskCenter
        }, {
          default: _withCtx(() => [
            _createTextVNode(" 查看全部 ")
          ]),
          _: 1
        })
      ], 4)
    ]),
    _createVNode(_component_a_drawer, {
      title: "任务详情",
      open: open.value,
      onClose: onClose
    }, {
      default: _withCtx(() => [
        _createVNode(Detail, { row: curRow.value }, null, 8, ["row"])
      ]),
      _: 1
    }, 8, ["open"])
  ], 64))
}
}

})